import { registerLocaleData } from '@angular/common';
import { environment } from '@environments/environment';
import localePT from '@angular/common/locales/pt-PT';
registerLocaleData(localePT);
var ɵ0 = environment.base_href, ɵ1 = environment.ga_indra, ɵ2 = environment.ga_tap;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1, ɵ2 };
